import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { add, deleteRecord, fetch, update } from '../services/CustomerSubscriptionsService';
import { CustomerSubscription } from '../types';

export const useCustomerSubscription = (customerSubscriptionId?: string) => {
    const queryClient = useQueryClient();

    const customerSubscriptionQuery = useQuery({
        queryKey: ['customer-subscription', customerSubscriptionId],
        queryFn: () => fetch(customerSubscriptionId!),
        enabled: !!customerSubscriptionId
    });

    const createMutation = useMutation({
        mutationFn: (values: CustomerSubscription) => {
            const { created: _created, createdByUsername: _createdByUsername, createdByUser: _createdByUser, updated: _updated, updatedByUsername: _updatedByUsername, ...cleanData } = values;
            return add(cleanData);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['customer-subscriptions'] });
        }
    });

    const updateMutation = useMutation({
        mutationFn: (values: CustomerSubscription) => {
            if (!customerSubscriptionId) throw new Error('customerSubscriptionId is required parameter');
            return update(customerSubscriptionId, values);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['customer-subscriptions'] });
            queryClient.invalidateQueries({ queryKey: ['customer-subscription', customerSubscriptionId] });
        }
    });

    const deleteMutation = useMutation({
        mutationFn: () => {
            if (!customerSubscriptionId) throw new Error('customerSubscriptionId is required parameter');
            return deleteRecord(customerSubscriptionId);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['customer-subscriptions'] });
        }
    });

    return {
        record: customerSubscriptionQuery.data,
        loading: customerSubscriptionQuery.isLoading,
        fetchRecord: customerSubscriptionQuery.refetch,
        createRecord: createMutation.mutate,
        updateRecord: updateMutation.mutate,
        deleteRecord: deleteMutation.mutate,
        createMutation,
        updateMutation,
        deleteMutation
    };
};